export default "__VITE_ASSET__a8a89d92__"